module.exports = __webpack_public_path__ + "static/img/fish44.d926ea4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish44.png
// module id = X9KF
// module chunks = 0